var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorScreenImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 136,
    viewBox: "0 0 136 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 68,
    r: 65,
    stroke: "#121212",
    strokeWidth: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M118 68C118 72.4967 117.406 76.8547 116.293 81M68 18C53.8619 18 41.0944 23.8679 32 33.3012M47 113.389C53.3851 116.349 60.4997 118 68 118C83.2077 118 96.8296 111.211 106 100.498",
    stroke: "#121212",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7846 54.0439L52.9383 66.1726C53.7202 66.9528 53.7202 68.2179 52.9383 68.9982L40.4005 81.5106C39.6187 82.2909 39.6187 83.5559 40.4005 84.3362L50.5561 94.4713C51.3379 95.2515 52.6055 95.2515 53.3874 94.4713L65.925 81.9591C66.7069 81.1788 67.9744 81.1788 68.7563 81.959L82.0115 95.187C82.7934 95.9672 84.0609 95.9672 84.8428 95.187L95.3314 84.7197C96.1132 83.9395 96.1132 82.6744 95.3313 81.8941L82.0762 68.6661C81.2943 67.8859 81.2943 66.6208 82.0761 65.8406L94.6139 53.3277C95.3957 52.5474 95.3957 51.2824 94.6139 50.5021L84.4583 40.367C83.6764 39.5868 82.4088 39.5868 81.6269 40.3671L69.0892 52.8799C68.3074 53.6601 67.0398 53.6602 66.2579 52.8799L54.1044 40.751C53.3226 39.9707 52.055 39.9707 51.2731 40.751L40.7846 51.2183C40.0027 51.9986 40.0027 53.2637 40.7846 54.0439Z",
    stroke: "#121212",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorScreenImage);
export default __webpack_public_path__ + "static/media/errorScreenImage.e93af9d205cf0d3314088c20746915e9.svg";
export { ForwardRef as ReactComponent };